import React from "react";
import { Container } from "react-bootstrap";
import Modul from "./modul";
import classes from './linkBlock.module.css';

const ModulList = ({title, moduls}) => {
    return(
        <Container fluid="md">
            <h2>{title}</h2>
            <div className={classes.modulBlock}>
                {moduls.map((modul, index) => 
                    <Modul number={index +1} modul={modul} key={modul.id}/>
                )}
            </div>
        </Container>
    )
}

export default ModulList;